import { Line } from "vue-chartjs";
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
export default {
  extends: Line,
  name: "LineChart",
  // Hilfvariablen werden in dieser Komponente entgegengenommen
  props: ["dataChart", "options", "countGraph", "countGraph2"],
  mounted() {
    // generate color gradient
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(66, 222, 250, 1)");
    this.gradient.addColorStop(0.5, "rgba(66, 222, 250, 0.3)");
    this.gradient.addColorStop(1, "rgba(66, 222, 250, 0)");

    for (let index = 0; index < this.dataChart.datasets.length; index++) {
      if (this.dataChart.datasets[index].label === "Umsätze pro Woche (SI & PottIT)") {
        this.dataChart.datasets[index].backgroundColor = this.gradient;
        this.dataChart.datasets[index].borderColor = "rgba(66, 222, 250, 0.8)";
        this.dataChart.datasets[index].borderWidth = 3.5;
      }  
    }



    
    this.renderTheChart();
  },
  // computed: {
  //   chartData() {
  //     return this.dataChart;
  //   }
  // },
  methods: {
    renderTheChart() {
      this.renderChart(this.dataChart, this.options);
    }
  },
  // Watcher der bei Veränderung von countGraph auslöst
  watch: {
    countGraph: {
      handler: function() {
        // if(this.countGraph!=0){
        for (var i = 0; i < this.dataChart.datasets.length - 1; i++) {
          var min = Math.ceil(0);
          var max = Math.floor(255);
          var math1 = Math.floor(Math.random() * (max - min)) + min;
          var math2 = Math.floor(Math.random() * (max - min)) + min;
          var math3 = Math.floor(Math.random() * (max - min)) + min;

          this.dataChart.datasets[i].borderColor = "rgba("+ math1 + "," + math2 + "," + math3 + ",0.8)";
        }
        // }
        // Neuladen der Chart
        this.$data._chart.update();
      },
      deep: true
    },
    countGraph2: {
      handler: function() {
        // Neuladen der Chart
        this.$data._chart.update();
      },
      deep: true
    }
  }
};
